
// Round to the provided number of decimals.
// Must be a positive integer or zero.
let roundDecimalPlaces = function(value, decPlaces) {
    decPlaces = decPlaces <= 0 ? 0 : Math.round(decPlaces)
    let factor = decPlaces == 0 ? 1 : 10 ** decPlaces
    return Math.round(value * factor) / factor
}

let distancePt = function(shape, centerPt, param, distance) {
    let cx = centerPt.x
    let cy = centerPt.y
    let startPt = {'x': cx, 'y': cy}
    let endPt = shape.getCoordinates(param)
    return {'x': roundDecimalPlaces(((endPt.x - startPt.x) * distance + startPt.x), 3), 'y': roundDecimalPlaces(((endPt.y - startPt.y) * distance + startPt.y), 3)}
}

let distanceConnect = function(shape, startParam, endParam, distance) {
    let startPt = shape.getCoordinates(startParam)
    // {'x': cx, 'y': cy}
    let endPt = shape.getCoordinates(endParam)
    return {'x': roundDecimalPlaces(((endPt.x - startPt.x) * distance + startPt.x), 3), 'y': roundDecimalPlaces(((endPt.y - startPt.y) * distance + startPt.y), 3)}
}

// This distance between two points
let getPointDistance = function(pt1, pt2) {
    return Math.sqrt((pt1.x - pt2.x) ** 2 + (pt1.y - pt2.y) ** 2)
}

let randomInRange = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min
} 

// Take the valueRange and use it to generate a number
// range is min / mid to max / mid,
// so for 5 ... 30, this is 5 / 17.5  to 30 / 17.5
let randomAdjustment = function(valueRange) {
    let mid = (Math.max(...valueRange) - Math.min(...valueRange)) / 2 + Math.min(...valueRange)
    mid = mid === 0 ? 1 : mid
    let value = randomInRange(...valueRange) / mid
    return value
} 


const randomFromRange = function(min, max) {
    return Math.random() * (max - min) + min
}


const randomWholeFromRange = function(min, max) {
    return Math.round(Math.random() * (max - min) + min)
}



// Takes two x/y points, calculates the center point between those two. 
// needed for determining where to place ctrl points
let getCenterPt = function(ptOne, ptTwo) {
    let xDiff = ptTwo.x - ptOne.x
    let yDiff = ptTwo.y - ptOne.y
    return {'x': ptOne.x + (xDiff / 2), 'y': ptOne.y + (yDiff / 2)}
}


let diffCalc = function(ptOne, ptTwo) {
    return {'xDiff': ptTwo.x - ptOne.x, 'yDiff': ptTwo.y - ptOne.y}
    // return {'xDiff': ptOne.x - ptTwo.x, 'yDiff': ptOne.y - ptTwo.y}
}

// Slope of the line
let getSlope = function(diffs) {
    if (diffs.yDiff === 0) {
        return 0
    }
    if (diffs.xDiff === 0) {
        return Infinity
    } 
    return diffs.yDiff / diffs.xDiff
}

// Slope of the perpendicular line
// used to determine where to place the off center points
let getPerpenSlope = function(slope){
    if (slope === Infinity) {
        return 0
    }
    if (slope === 0) {
        return Infinity
    }
    return - (1 / slope)
}

// Get the angle between two lines with the slope only
let angleBetweenLines = function(slope1, slope2) {
    return roundDecimalPlaces(Math.abs(Math.atan((slope2 - slope1) / (1 + slope1 * slope2))), 4)
}


// Get angles in a triangle using law of cosines -
// Uses the lengths of all sides, but has no angle requirement.  
// sideA is opposite, sideC/B are on either side of the angle
let lawCosinesAngle = function(sideA, sideB, sideC) {
    let angleRads = Math.acos((sideB ** 2 + sideC ** 2 - sideA ** 2) / (2 * sideB * sideC))
    return angleRads
}

let rotationCalc = function(pt1, pt2, pt3) {
    let val = (pt2.y - pt1.y) * (pt3.x - pt2.x) - (pt2.x - pt1.x) * (pt3.y - pt2.y)
    if (val == 0) return 'neither'
    return (val > 0) ? 'clock' : 'counter'
}


// Two vectors, (pt1 -> pt2) and (pt1 -> pt3)
// calculate the vectors, then do the 
// cross product.  
// The result is the area of the parallelogram between, 
// with a Positive value if V2 is counterclock from V1, and 
// negative otherwise
// pt1 needs to always stay the same in these calcs
let crossProd = function(pt1, pt2, pt3) {
    let v1x = pt2.x - pt1.x
    let v1y = pt2.y - pt1.y
    let v2x = pt3.x - pt1.x
    let v2y = pt3.y - pt1.y
    return (v1x * v2y) - (v2x * v1y)
}

// I am using the regular Cross Product 
// because I want to sort counterclockwise,
// which it does because of the reverse of coordinates in svg
// doing the regular cross product produces negatives going clockwise.
// The result should be the same however
let sortEdgesByCrossProd = function(startEdge, edges) {
    return [startEdge, ...edges.sort((a, b) => -crossProd(startEdge.center, a.center, b.center) || a.center.y - b.center.y)]
}

let sortPointsByCrossProd = function(startPt, points) {
    return [startPt, ...points.sort((a, b) => -crossProd(startPt, a, b) || (a.y - b.y) + (a.x - b.x))]
}


// These will be used to work out where to place the ctrl point. 
// Can run them through the formula to work out which direction to bend the
// line
let getOffCenterPoints = function(xDiff, yDiff, centerPt, slope, factor) {
    let recip = getPerpenSlope(slope)
    // Get the x factor for the adjustment
    if (recip === 0) {
        // There is no y change in the reciprocal
        return [
            {'x': centerPt.x + (xDiff * factor), 'y': centerPt.y},
            {'x': centerPt.x - (xDiff * factor), 'y': centerPt.y}
        ]
    } 
    if (recip === Infinity) {
        // There is no x change in the reciprocal
        return [
            {'x': centerPt.x, 'y': centerPt.y + (yDiff * factor)},
            {'x': centerPt.x, 'y': centerPt.y - (yDiff * factor)}
        ]

    }
    // DONT NEED - you have the xDiff/yDiff, which represent run/rise, 
    // so just reverse those multiplied by the factor
    let xRecip = xDiff / recip
    let yRecip = yDiff * recip
    return [
            {'x': centerPt.x + (yDiff * factor), 'y': centerPt.y - (xDiff * factor)},
            {'x': centerPt.x - (yDiff * factor), 'y': centerPt.y + (xDiff * factor)}
        ]
}

// Determine a ctrl point to use to bend the 
// line outward away from the direction of turn to give a more 
// seamless appearance
let determineCurveBend = function(ptOne, ptTwo, ptThree) {

    // Get the slopes and then the direction change.
    // Direction is clockwise if the change is positive, 
    // counterclockwise if negative
    let change = rotationCalc(ptOne, ptTwo, ptThree)
    
    // There is a well established formula for the angle of intersect
    // between lines
    let diffs1 = diffCalc(ptOne, ptTwo)
    let diffs2 = diffCalc(ptTwo, ptThree)
    let slope1 = getSlope(diffs1) 
    let slope2 = getSlope(diffs2)

    // This is the angle between two lines formula, will likely come in 
    // use other places too.  
    let angleRads = Math.abs(Math.atan((slope2 - slope1) / (1 + slope1 * slope2)))
    // I think the max angle is 180, so scale the factor 
    // 0 - 1 based on that
    let factor = angleRads / Math.PI
    
    let centerPt = getCenterPt(ptOne, ptTwo)
    let offCenter = getOffCenterPoints(diffs1.xDiff, diffs1.yDiff, centerPt, slope1, factor)
    let chosenPt = centerPt
    let direction
    for (let offPt of offCenter) {
        let rotate = rotationCalc(ptOne, ptTwo, offPt)
        if (change !== rotate) {
            chosenPt = offPt
            direction = rotate
            break
        }
    }
    return [chosenPt, offCenter, direction, factor]
}


// In this case have only two points, but will use an existing 
// direction and factor to bend the line. 
// Direction is just clockwise, counterclockwise, or neither
// if the points lie on a straight line.  
// Factor is how much to bend the line relative to the length 
// of the line.
let preDetermineCurveBend = function(ptOne, ptTwo, direction, factor) {
    // There is a well established formula for the angle of intersect
    // between lines
    let diffs1 = diffCalc(ptOne, ptTwo)
    let slope1 = getSlope(diffs1) 
    
    let centerPt = getCenterPt(ptOne, ptTwo)
    let offCenter = getOffCenterPoints(diffs1.xDiff, diffs1.yDiff, centerPt, slope1, factor)
    let chosenPt = centerPt
    for (let offPt of offCenter) {
        let rotate = rotationCalc(ptOne, ptTwo, offPt)
        if (direction == rotate) {
            chosenPt = offPt
            direction = rotate
            break
        }
    }
    return [chosenPt, offCenter]
}

let addBoundaryPoints = function(minX, minY, maxX, maxY, numberPerSide) {
    // It will go right, top, left, bottom
    let points = []
    let sides = new Map([['minX', minX],['minY', minY],['maxX', maxX],['maxY', maxY]])
    // Merging these with the sides map will adjust the 
    // randomizer to provide point along a single line at a time
    // offset factor is used to make sure points are not exactly the same
    // which causes problems with my edge sort/unique algos
    let off = 10000
    let sideAdjust = [
        new Map([['minX', maxX - Math.random() / off]]), 
        new Map([['maxY', minY + Math.random() / off]]),
        new Map([['maxX', minX + Math.random() / off]]),
        new Map([['minY', maxY - Math.random() / off]])
    ]
    for (let side of sideAdjust) {
        let adjustedMap = new Map([...sides, ...side]).values()
        // Turning the map values into an array is lousy
        // syntax but does work, maybe turn to an array
        points.push(...generateNPoints(...[...adjustedMap], numberPerSide))
    }
    return points
}

let pointGenerator = function(minX, minY, maxX, maxY) {
    let xRange = maxX - minX
    let yRange = maxY - minY
    let randX = minX + Math.random() * xRange
    let randY = minY + Math.random() * yRange
    return {'x': randX, 'y': randY}
}

let generateNPoints = function(minX, minY, maxX, maxY, number) {
    let points = []
    for (let i = 0; i < number; i++) {
        points.push(pointGenerator(minX, minY, maxX, maxY))
    }
    return points
}

let ensureIsArray = function(input) {
    if (!Array.isArray(input)) {
        input = [input]
    }
    return input
}

export { ensureIsArray, roundDecimalPlaces, distancePt, distanceConnect, randomInRange, randomAdjustment, determineCurveBend, getCenterPt, preDetermineCurveBend, diffCalc, getSlope, angleBetweenLines, lawCosinesAngle, sortEdgesByCrossProd, sortPointsByCrossProd, generateNPoints, addBoundaryPoints, getPointDistance, randomFromRange, randomWholeFromRange }
